/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { util } from 'fabric';
import { unitToPixels } from 'shared/libs/utils/numbers';
import { calculateObjectCenter } from '../utils';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';

const __vue_script__ = {
    name: 'ArrangementControls',

    components: {
        ExpandableContent,
    },

    props: {
        pageDimensions: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        }
    },

    methods: {
        calculateRotatedCorners() {
            const radians = util.degreesToRadians(this.value.angle || 0);
            const cos = Math.cos(radians);
            const sin = Math.sin(radians);
            const { width, height, left, top } = this.value;
            const corners = [
                { x: 0, y: 0 },
                { x: width, y: 0 },
                { x: width, y: height },
                { x: 0, y: height }
            ];

            return corners.map(({ x, y }) => ({
                x: left + x * cos - y * sin,
                y: top + x * sin + y * cos,
            }));
        },
        handleArrangementClick(event) {
            const button = event.target.closest('button');
            const arrangement = button?.dataset?.align;
            if (!arrangement) return;

            const { width, height, dpi, unit } = this.pageDimensions;
            const canvasSize = {
                width: unitToPixels(width, dpi, unit),
                height: unitToPixels(height, dpi, unit),
            };
            let { top, left } = this.value;

            switch (arrangement) {
                case 'top': {
                    top = top - Math.min(...this.calculateRotatedCorners().map(({ y }) => y));
                    break;
                }
                case 'middle': {
                    top = top + canvasSize.height / 2 - calculateObjectCenter(this.value).top;
                    break;
                }
                case 'bottom': {
                    top = top + canvasSize.height - Math.max(...this.calculateRotatedCorners().map(({ y }) => y));
                    break;
                }
                case 'left': {
                    left = left - Math.min(...this.calculateRotatedCorners().map(({ x }) => x));
                    break;
                }
                case 'center': {
                    left = left + canvasSize.width / 2 - calculateObjectCenter(this.value).left;
                    break;
                }
                case 'right': {
                    left = left + canvasSize.width - Math.max(...this.calculateRotatedCorners().map(({ x }) => x));
                    break;
                }
            }

            this.$emit('input', { ...this.value, top, left });
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "arrangement-controls form-group" }, [
    _c("label", { staticClass: "label-control" }, [
      _vm._v(
        _vm._s(_vm.$t("onsite_scanning.badge_editor.parameters.arrangement"))
      ),
    ]),
    _c(
      "div",
      { staticClass: "arrangement", on: { click: _vm.handleArrangementClick } },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-ctx-icon btn-primary",
            attrs: {
              "data-align": "left",
              title: _vm.$t("onsite_scanning.badge_editor.left"),
            },
          },
          [_c("i", { staticClass: "icon ic-align-position-left" })]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-ctx-icon btn-primary",
            attrs: {
              "data-align": "right",
              title: _vm.$t("onsite_scanning.badge_editor.right"),
            },
          },
          [_c("i", { staticClass: "icon ic-align-position-right" })]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-ctx-icon btn-primary",
            attrs: {
              "data-align": "center",
              title: _vm.$t("onsite_scanning.badge_editor.center"),
            },
          },
          [_c("i", { staticClass: "icon ic-align-position-center" })]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-ctx-icon btn-primary",
            attrs: {
              "data-align": "middle",
              title: _vm.$t("onsite_scanning.badge_editor.middle"),
            },
          },
          [_c("i", { staticClass: "icon ic-align-position-middle" })]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-ctx-icon btn-primary",
            attrs: {
              "data-align": "top",
              title: _vm.$t("onsite_scanning.badge_editor.top"),
            },
          },
          [_c("i", { staticClass: "icon ic-align-position-top" })]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-ctx-icon btn-primary",
            attrs: {
              "data-align": "bottom",
              title: _vm.$t("onsite_scanning.badge_editor.bottom"),
            },
          },
          [_c("i", { staticClass: "icon ic-align-position-bottom" })]
        ),
      ]
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/editors/badge-editor/panels/ArrangementControls.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__